import script from "./ConnectEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectEmpty.vue?vue&type=script&setup=true&lang=ts"

import "./ConnectEmpty.vue?vue&type=style&index=0&id=2b4031b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4031b7"]])

export default __exports__